import {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'

import {PageTitle} from 'src/cms/layout/core'

import DuplicateCIFCheck from './component.tsx/DuplicateCIFCheck'

import {useSelector} from 'react-redux'
import {RootState} from 'src/setup'
import useGetMasterDataStore from 'src/cms/hooks/get/masterData/usePostMasterData'
// import useGetMasterData from 'src/cms/hooks/get/masterData/usePostMasterData'

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  // const authResp = useSelector((state: any) => state.auth)
  // const {user} = authResp
  // const userRole = user?.data?.role?.name as string
  // const cardData =
  //   (DashboardCardData as DashboardCardDataIndex)[userRole] || DashboardCardData['branchmaker']
  const masterSelector = useSelector(
    (state: RootState) => state.allMasterDataOptions.allMasterDataOptions
  )
  const {mutate} = useGetMasterDataStore()

  useEffect(() => {
    mutate()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DuplicateCIFCheck />
    </>
  )
}

export {DashboardWrapper}
